export default __webpack_public_path__ + "static/media/icon-sertifikat.4f294044.png";